import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'nexus-card',
  templateUrl: './nexus-card.component.html',
  styleUrls: ['./nexus-card.component.scss']
})
export class NexusCardComponent implements OnInit {
  @Input() public card_title: string;

  constructor() { }

  ngOnInit() {
  }

}
